import React from "react";
import ReactDOM from 'react-dom';
import ListingIndex from "./components/ListingIndex";
import FavouritesPage from "./components/FavouritesPage";
import FavButton from "./components/FavButton";
import ItineraryPage from "./components/ItineraryPage";

export default () => {

    const listingIndex = document.querySelector('[data-list-page]');
    if (listingIndex) {
        ReactDOM.render(
            <ListingIndex />,
            listingIndex
        )
    }

    const favIndex = document.querySelector('[data-fav-page]');
    if (favIndex) {
        ReactDOM.render(
            <FavouritesPage
                configs={JSON.parse(document.querySelector('[name="_CategoryMap"]').getAttribute('content'))}
            />,
            favIndex
        )
    }

    const intIndex = document.querySelector('[data-int-page]');
    if (intIndex) {
        ReactDOM.render(
            <ItineraryPage
                configs={JSON.parse(intIndex.getAttribute('data-configs'))}
            />,
            intIndex
        )
    }

    const favIcons = document.querySelectorAll('[data-fav-listing]');
    for(const icon of favIcons) {
        const id = icon.getAttribute('data-fav-listing');
        const isButton = icon.getAttribute('data-fav-button');
        ReactDOM.render(
            <FavButton isButton={isButton == "1"} id={id} />,
            icon
        )
    }

}

